<template>
  <div
    class="anz-post__parent-annotation anz-mb-xs"
    :class="{ expanded: truncated & expanded }"
  >
    <post-single-violation
      v-if="isParentHidden()"
      :post="postRoot.parentPost"
      is-parent-violation
    />
    <div class="anz-bg-gray-200 anz-color-black-70 anz-cf anz-b-rounded">
      <a-button
        className="anz-link anz-bg-gray-200 anz-color-black-70 anz-ml-l-sm anz-fr anz-flex anz-align-items-center anz-justify-content-center anz-b-rounded"
        :style="{ width: '3.4285em', height: '2.3846em' }"
        v-if="truncated"
        @click="expanded = !expanded"
      >
        <template #title>
          <a-icon
            v-if="expanded"
            name="chevron-up"
            width="1.285em"
            height="1.285em"
          />
          <a-icon v-else name="chevron-down" width="1.285em" height="1.285em" />
        </template>
      </a-button>
      <div
        class="anz-pl-s anz-pr-xs anz-pr-l-sm anz-py-xs anz-bg-gray-200 anz-color-black-70 anz-b-rounded"
        v-if="postRoot.parentPost.content.length > 0"
      >
        <div
          class="anz-post__parent-annotation-text-wrapper anz-flex anz-py-xxs"
        >
          <div ref="annotation" class="anz-post__parent-annotation-text">
            <span class="anz-mr-xs anz-color-gray-700"
              >{{ postRoot.parentPost.author.nickname }}:</span
            >
            <span v-html="postRoot.parentPost.content"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import AIcon from '@/components/AIcon.vue'
import PostSingleViolation from '@/components/Post/PostSingleViolation.vue'
import { SettingsStatus } from '@/model/data-object/Post'

export default defineComponent({
  name: 'PostSingleParent',
  components: { PostSingleViolation, AButton, AIcon },
  props: {
    postRoot: {
      // type: Post, // todo change type to POST
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      truncated: false,
      expanded: false,
    }
  },
  methods: {
    isTruncated() {
      const annotation: any = this.$refs.annotation
      if (typeof annotation === 'undefined') {
        return false
      }

      return (
        annotation.clientWidth < annotation.scrollWidth ||
        annotation.clientHeight < annotation.scrollHeight
      )
    },
    isParentHidden() {
      return [SettingsStatus.HIDDEN, SettingsStatus.GDPR_DELETED].includes(
        this.postRoot.parentPost.status
      )
    },
  },
  watch: {
    annotation(val) {
      if (val) {
        this.truncated = this.isTruncated()
      }
    },
  },
  mounted() {
    this.truncated = this.isTruncated()
  },
  setup() {
    const annotation = ref(null)

    return { annotation }
  },
})
</script>
